import styled from 'styled-components'

import theme from '../../../utils/theme'

export const NXDropdownWrapper = styled.div`
  position: relative;
  line-height: 1;
  margin-right: 10px;
  border: ${theme.borders.default};
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  height: 35px;
  .dropdown-text {
    flex-grow: 1;
    padding: 10px 10px 9px;
    color: #4a4a4a;
  }
  .dropdown-button {
    width: 100%;
    display: inline-flex;
    justify-content: space-between;
    .dropdown-icon {
      padding: 10px 7px;
    }
  }
  &:hover {
    cursor: pointer;
  }
  .dropdown-content {
    display: block;
    position: absolute;
    background-color: ${props => props.theme.dropdown.dropdownBg};
    box-shadow: ${props => props.theme.dropdown.dropdownBoxShadow};
    z-index: 1;
    list-style-type: none;
    min-width: 200px;
    max-height: 300px;
    overflow: scroll;
    .com-dropdown-item {
      line-height: 1.3;
      &:hover {
        background-color: ${props => props.theme.dropdown.dropdownLinkHoverBg};
      }
    }
  }
`
